module.exports = __webpack_public_path__ + "img/Entertainment.b2cfe5a0.svg";